import { Outlet, useLocation } from "react-router-dom";
import Breadcrumb from "./Breadcrumb";
import { Check } from "lucide-react";
import { useTranslation } from "react-i18next";

const Payment = ({ page, }) => {
    const location = useLocation();
    const { t } = useTranslation();
    return (
        <>
            <Breadcrumb pages={[t(`routes.${page}`), t('routes.payment')]} />
            <main className="grid grid-cols-[29%_69%] gap-4 py-4 px-20 max-lg:px-3 max-lg:grid-cols-1">
                <div className="border-[var(--secondary-color)] border rounded-xl px-8 py-4 flex flex-col gap-1 justify-center h-fit">

                    {/* LOGIN */}
                    <div className="flex items-center gap-2">
                        <div className={`flex justify-center items-center size-10 rounded-full border-[var(--secondary-color)] ${!location.pathname.includes('login') ? ' bg-secondary-tw' : ''}  border-2`}>

                            <Check size={25}
                                color={`${location.pathname.includes('login') ?
                                    'var(--secondary-color)' :
                                    !location.pathname.includes('login') ? 'white' : '#C6C6C6'}`} />

                        </div>
                        <div className="text-start" style={{ fontSize: '14px' }}>
                            <p className={`text-semi-gray text-base`}>
                                {t('payment.first-step')}
                            </p>
                            <p className={`text-secondary-tw`}>{t('routes.login')}</p>
                        </div>
                    </div>

                    <div className={`w-1 h-14 rounded-md mx-3 bg-secondary-tw`}></div>

                    {/* CHOOSE PAYMENT */}
                    <div className="flex items-center gap-2">
                        <div className={`flex justify-center items-center size-10 rounded-full ${location.pathname.includes('card') || location.pathname.includes('way') ? 'border-[var(--secondary-color)]' : 'border-[#C6C6C6]'} ${location.pathname.includes('card') ? 'bg-secondary-tw' : ''} border-2`}>
                            <Check size={25}
                                color={`${location.pathname.includes('way') ?
                                    'var(--secondary-color)' :
                                    location.pathname.includes('card') ? 'white' : '#C6C6C6'}`} />
                        </div>
                        <div className="text-start">
                            <p className={`text-semi-gray text-base`}>
                                {t('payment.sec-step')}
                            </p>
                            <p className={`${location.pathname.includes('way') || location.pathname.includes('card') ? 'text-secondary-tw' : 'text-[#C6C6C6]'} text-sm`}>{t('payment.choose-way')}</p>
                        </div>
                    </div>

                    <div className={`w-1 h-14 rounded-md mx-3 ${!location.pathname.includes('login') ? 'bg-secondary-tw' : 'bg-[#C6C6C6]'}`}></div>

                    {/* PAYMENT DATA */}
                    <div className="flex items-center gap-2">
                        <div
                            className={`flex justify-center items-center size-10 rounded-full ${location.pathname.includes('card') ? 'border-[var(--secondary-color)]' : 'border-[#C6C6C6]'} ${location.pathname.includes('done') ? 'bg-secondary-tw' : ''} border-2`}>
                            <Check size={25}
                                color={`${location.pathname.includes('card') ?
                                    'var(--secondary-color)' :
                                    location.pathname.includes('done') ? 'white' : '#C6C6C6'}`} />
                        </div>
                        <div className="text-start">
                            <p className={`text-semi-gray text-base`}>
                                {t('payment.third-step')}
                            </p>
                            <p className={`${location.pathname.includes('card') ? 'text-secondary-tw' : 'text-[#C6C6C6]'} text-sm`}>{t('payment.data')}</p>
                        </div>
                    </div>
                </div>
                <main>
                    <Outlet />
                </main>
            </main>
        </>
    )
}
export default Payment;